import { render, staticRenderFns } from "./fangkuai.vue?vue&type=template&id=5be8749e&scoped=true&"
import script from "./fangkuai.vue?vue&type=script&lang=js&"
export * from "./fangkuai.vue?vue&type=script&lang=js&"
import style0 from "./fangkuai.vue?vue&type=style&index=0&id=5be8749e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8749e",
  null
  
)

export default component.exports